module.exports = __webpack_public_path__ + "assets/img/securitiesscenario_list_active_bg.a6eb40c5.png";